var map = {
	"./10k-drive.svg": [
		38329,
		[
			3991
		]
	],
	"./18-plus.svg": [
		91644,
		[
			3991
		]
	],
	"./18plus.svg": [
		10595,
		[
			3991
		]
	],
	"./18plusMrGreen.svg": [
		94935,
		[
			3991
		]
	],
	"./24h.svg": [
		33086,
		[
			3991
		]
	],
	"./888club.svg": [
		36436,
		[
			3991
		]
	],
	"./888club2.svg": [
		62030,
		[
			3991
		]
	],
	"./888wetten.svg": [
		29257,
		[
			3991
		]
	],
	"./AvatarIcon.svg": [
		13628,
		[
			5371
		]
	],
	"./Icon-18.svg": [
		38631,
		[
			3991
		]
	],
	"./Sjalvtest.svg": [
		11514,
		[
			3991
		]
	],
	"./SjalvtestMrGreen.svg": [
		73248,
		[
			3991
		]
	],
	"./Spelgranser.svg": [
		15850,
		[
			3991
		]
	],
	"./SpelgranserMrGreen.svg": [
		464,
		[
			3991
		]
	],
	"./Spelpaus.svg": [
		52875,
		[
			3991
		]
	],
	"./SpelpausMrGreen.svg": [
		62159,
		[
			3991
		]
	],
	"./about-us.svg": [
		7444,
		[
			3991
		]
	],
	"./account-statement.svg": [
		1525,
		[
			3991
		]
	],
	"./account.svg": [
		17653,
		[
			3991
		]
	],
	"./add-user.svg": [
		75535,
		[
			3991
		]
	],
	"./alert.svg": [
		56402,
		[
			3991
		]
	],
	"./app-download.svg": [
		25894,
		[
			3991
		]
	],
	"./az-sports.svg": [
		49087,
		[
			3991
		]
	],
	"./back-btn.svg": [
		84890,
		[
			3991
		]
	],
	"./be-gamble-aware.svg": [
		68169,
		[
			3991
		]
	],
	"./bell.svg": [
		37995,
		[
			3991
		]
	],
	"./bet-feed-old.svg": [
		36966,
		[
			3991
		]
	],
	"./bet-feed.svg": [
		8650,
		[
			3991
		]
	],
	"./betfeed-mrg.svg": [
		82106,
		[
			3991
		]
	],
	"./biometrics-login.svg": [
		26245,
		[
			3991
		]
	],
	"./blog.svg": [
		58756,
		[
			3991
		]
	],
	"./bonuses.svg": [
		46485,
		[
			3991
		]
	],
	"./burger-old.svg": [
		57295,
		[
			3991
		]
	],
	"./burger.svg": [
		51479,
		[
			3991
		]
	],
	"./casino-daily-wish.svg": [
		13123,
		[
			3991
		]
	],
	"./casino-game.svg": [
		69564,
		[
			3991
		]
	],
	"./casino-history.svg": [
		94042,
		[
			3991
		]
	],
	"./casino-mrg.svg": [
		99558,
		[
			3991
		]
	],
	"./casino-si.svg": [
		87870,
		[
			3991
		]
	],
	"./challanges-shield.svg": [
		73424,
		[
			3991
		]
	],
	"./challenges.svg": [
		46866,
		[
			3991
		]
	],
	"./chat.svg": [
		35514,
		[
			3991
		]
	],
	"./check.svg": [
		50240,
		[
			3991
		]
	],
	"./clock.svg": [
		79274,
		[
			3991
		]
	],
	"./close-x.svg": [
		65483,
		[
			3991
		]
	],
	"./close.svg": [
		71084,
		[
			3991
		]
	],
	"./confirmed.svg": [
		87187,
		[
			3991
		]
	],
	"./control-center.svg": [
		63891,
		[
			3991
		]
	],
	"./cool_arrow.svg": [
		99421,
		[
			3991
		]
	],
	"./cross-casino-logo.svg": [
		8492,
		[
			3991
		]
	],
	"./cross-poker-logo.svg": [
		12220,
		[
			3991
		]
	],
	"./cross-sell-casino-mobile.svg": [
		47802,
		[
			3991
		]
	],
	"./cross-sell-casino.svg": [
		44827,
		[
			3991
		]
	],
	"./cross-sell-poker-mobile.svg": [
		51616,
		[
			3991
		]
	],
	"./cross-sell-poker.svg": [
		61253,
		[
			3991
		]
	],
	"./cross-sell-sport-mobile.svg": [
		66783,
		[
			3991
		]
	],
	"./cross-sell-sport.svg": [
		19052,
		[
			3991
		]
	],
	"./cross-sport-logo.svg": [
		14971,
		[
			3991
		]
	],
	"./de-migration-logo.svg": [
		22918,
		[
			3991
		]
	],
	"./default-icon.svg": [
		73587,
		[]
	],
	"./default-logo.svg": [
		58845,
		[
			3991
		]
	],
	"./deposit.svg": [
		85098,
		[
			3991
		]
	],
	"./depositLimit.svg": [
		75575,
		[
			3991
		]
	],
	"./dice.svg": [
		81129,
		[
			3991
		]
	],
	"./disconnect-error.svg": [
		1971,
		[
			3991
		]
	],
	"./disconnect.svg": [
		52270,
		[
			3991
		]
	],
	"./disconnected.svg": [
		95137,
		[
			3991
		]
	],
	"./document-checked.svg": [
		76775,
		[
			3991
		]
	],
	"./document.svg": [
		9387,
		[
			3991
		]
	],
	"./documentWithTimer.svg": [
		49374,
		[
			3991
		]
	],
	"./download-app.svg": [
		710,
		[
			3991
		]
	],
	"./download.svg": [
		73416,
		[
			3991
		]
	],
	"./e-magazine.svg": [
		29600,
		[
			3991
		]
	],
	"./email.svg": [
		9120,
		[
			3991
		]
	],
	"./face-id.svg": [
		22315,
		[
			3991
		]
	],
	"./financial.svg": [
		45117,
		[
			3991
		]
	],
	"./finger-print.svg": [
		42849,
		[
			3991
		]
	],
	"./flag.svg": [
		92982,
		[
			3991
		]
	],
	"./football.svg": [
		25563,
		[
			3991
		]
	],
	"./free-bets.svg": [
		73331,
		[
			3991
		]
	],
	"./free-play.svg": [
		821,
		[
			3991
		]
	],
	"./freespin.svg": [
		70082,
		[
			3991
		]
	],
	"./gam-care.svg": [
		67609,
		[
			3991
		]
	],
	"./game-frame-close.svg": [
		9485,
		[
			3991
		]
	],
	"./game-frame-eighteenplus.svg": [
		42396,
		[
			3991
		]
	],
	"./game-frame-expand.svg": [
		19247,
		[
			3991
		]
	],
	"./game-frame-shrink.svg": [
		24900,
		[
			3991
		]
	],
	"./games.svg": [
		79993,
		[
			3991
		]
	],
	"./gaming.svg": [
		8327,
		[
			3991
		]
	],
	"./gear.svg": [
		51049,
		[
			3991
		]
	],
	"./globe.svg": [
		81503,
		[
			3991
		]
	],
	"./green-gaming.svg": [
		30201,
		[
			3991
		]
	],
	"./help-link.svg": [
		52934,
		[
			3991
		]
	],
	"./help.svg": [
		78601,
		[
			3991
		]
	],
	"./history-new.svg": [
		60549,
		[
			3991
		]
	],
	"./history.svg": [
		28736,
		[
			3991
		]
	],
	"./home-new.svg": [
		84480,
		[
			3991
		]
	],
	"./home.svg": [
		3213,
		[
			3991
		]
	],
	"./hourglass.svg": [
		11958,
		[
			3991
		]
	],
	"./how-to-deposit.svg": [
		53369,
		[
			3991
		]
	],
	"./how-to-play.svg": [
		93735,
		[
			3991
		]
	],
	"./icon-profile.svg": [
		42483,
		[
			3991
		]
	],
	"./info-tip.svg": [
		19956,
		[
			3991
		]
	],
	"./info.svg": [
		51652,
		[
			3991
		]
	],
	"./inplay.svg": [
		93279,
		[
			3991
		]
	],
	"./invite-a-friend.svg": [
		99982,
		[
			3991
		]
	],
	"./leaderboard-new.svg": [
		45880,
		[
			3991
		]
	],
	"./light.svg": [
		98764,
		[
			8228
		]
	],
	"./live-now-side-menu.svg": [
		53045,
		[
			3991
		]
	],
	"./live-old.svg": [
		26914,
		[
			3991
		]
	],
	"./live.svg": [
		19286,
		[
			3991
		]
	],
	"./localization-language.svg": [
		60242,
		[
			3991
		]
	],
	"./localization-pin.svg": [
		33289,
		[
			3991
		]
	],
	"./location-pin.svg": [
		99943,
		[
			3991
		]
	],
	"./location-plugin.svg": [
		10491,
		[
			3991
		]
	],
	"./location-plugin_si.svg": [
		85602,
		[
			3991
		]
	],
	"./location-search-pin.svg": [
		41792,
		[
			3991
		]
	],
	"./locker.svg": [
		74212,
		[
			3991
		]
	],
	"./logo-18-plus.svg": [
		90430,
		[
			3991
		]
	],
	"./logo-DGA-spillemyndigheden.svg": [
		18338,
		[
			3991
		]
	],
	"./logo-SI-desktop-red-white.svg": [
		87899,
		[
			3991
		]
	],
	"./logo-SI-mobile-header-white.svg": [
		63273,
		[
			3991
		]
	],
	"./logo-abon.svg": [
		25760,
		[
			3991
		]
	],
	"./logo-egt.svg": [
		26134,
		[
			3991
		]
	],
	"./logo-mrg-mobile.svg": [
		73925,
		[
			3991
		]
	],
	"./logo-mrg.svg": [
		21894,
		[
			7752
		]
	],
	"./logo-oktocash.svg": [
		67010,
		[
			3991
		]
	],
	"./logo-rofus.svg": [
		66203,
		[
			3991
		]
	],
	"./logo-spil-ansvarligt.svg": [
		32186,
		[
			3991
		]
	],
	"./logo-stop-spillet.svg": [
		69360,
		[
			3991
		]
	],
	"./logout.svg": [
		31834,
		[
			3991
		]
	],
	"./map-circle-vi.svg": [
		88763,
		[
			3991
		]
	],
	"./map-circle.svg": [
		22295,
		[
			3991
		]
	],
	"./map-circle_si.svg": [
		95182,
		[
			3991
		]
	],
	"./menu-spinner.svg": [
		58413,
		[
			3991
		]
	],
	"./migrationro-hours.svg": [
		21295,
		[
			3991
		]
	],
	"./migrationro-oneapp.svg": [
		86783,
		[
			3991
		]
	],
	"./migrationro-tournaments.svg": [
		88002,
		[
			3991
		]
	],
	"./mobile-light.svg": [
		91237,
		[
			3991
		]
	],
	"./moneyWallet.svg": [
		21443,
		[
			3991
		]
	],
	"./more.svg": [
		66691,
		[
			3991
		]
	],
	"./mrgreen-myaccount-area.svg": [
		75252,
		[
			3991
		]
	],
	"./notification.svg": [
		29301,
		[
			3991
		]
	],
	"./odds.svg": [
		96958,
		[
			3991
		]
	],
	"./offers.svg": [
		30901,
		[
			3991
		]
	],
	"./perfect-10.svg": [
		11523,
		[
			3991
		]
	],
	"./plus-cashier-mr-green.svg": [
		89234,
		[
			5847
		]
	],
	"./plus-cashier.svg": [
		59388,
		[
			2990
		]
	],
	"./poker-history.svg": [
		89720,
		[
			3991
		]
	],
	"./poker-mrg.svg": [
		3880,
		[
			3991
		]
	],
	"./poker.svg": [
		48039,
		[
			3991
		]
	],
	"./pokerCards.svg": [
		7868,
		[
			3991
		]
	],
	"./pokerDownloadUser.svg": [
		39658,
		[
			3991
		]
	],
	"./poker_logo.svg": [
		60835,
		[
			3991
		]
	],
	"./poker_logo_mobile.svg": [
		50292,
		[
			3991
		]
	],
	"./popular.svg": [
		74175,
		[
			3991
		]
	],
	"./popupLight.svg": [
		34634,
		[
			609
		]
	],
	"./promotions-prelogin.svg": [
		67029,
		[
			3991
		]
	],
	"./promotions.svg": [
		41218,
		[
			3991
		]
	],
	"./question-mark.svg": [
		16090,
		[
			3991
		]
	],
	"./real-money-poker.svg": [
		28291,
		[
			3991
		]
	],
	"./recommendations-old.svg": [
		38440,
		[
			3991
		]
	],
	"./recommendations.svg": [
		50768,
		[
			3991
		]
	],
	"./rectangle-poker.svg": [
		96895,
		[
			3991
		]
	],
	"./redeem-gold-token.svg": [
		62499,
		[
			3991
		]
	],
	"./redirect-focus.svg": [
		63907,
		[
			3991
		]
	],
	"./register.svg": [
		56107,
		[
			3991
		]
	],
	"./responsible-gaming.svg": [
		72426,
		[
			3991
		]
	],
	"./result_arrow.svg": [
		59637,
		[
			3991
		]
	],
	"./reverse-withdraw.svg": [
		45225,
		[
			3991
		]
	],
	"./rewards.svg": [
		84244,
		[
			3991
		]
	],
	"./search.svg": [
		13060,
		[
			3991
		]
	],
	"./security.svg": [
		94090,
		[
			3991
		]
	],
	"./session.svg": [
		84868,
		[
			3991
		]
	],
	"./shield.svg": [
		50811,
		[
			3991
		]
	],
	"./special-offers.svg": [
		32023,
		[
			3991
		]
	],
	"./sport-history.svg": [
		8645,
		[
			3991
		]
	],
	"./sport-mrg.svg": [
		9633,
		[
			3991
		]
	],
	"./sport.svg": [
		48142,
		[
			3991
		]
	],
	"./sport_cross_sell.svg": [
		70114,
		[
			3991
		]
	],
	"./sport_logo.svg": [
		62056,
		[
			3991
		]
	],
	"./sport_logo_VIP.svg": [
		63296,
		[
			3991
		]
	],
	"./sport_logo_mobile.svg": [
		6805,
		[
			3991
		]
	],
	"./sportwetten.svg": [
		94247,
		[
			3991
		]
	],
	"./sportwetten_VIP.svg": [
		90939,
		[
			3991
		]
	],
	"./sportwetten_mobile.svg": [
		7624,
		[
			3991
		]
	],
	"./star-empty.svg": [
		97484,
		[
			3991
		]
	],
	"./star.svg": [
		52344,
		[
			3991
		]
	],
	"./starting_soon.svg": [
		2018,
		[
			3991
		]
	],
	"./theme-mode.svg": [
		27505,
		[
			3991
		]
	],
	"./ticket.svg": [
		46444,
		[
			3991
		]
	],
	"./tickets-new.svg": [
		51482,
		[
			3991
		]
	],
	"./title_races.svg": [
		28709,
		[
			3991
		]
	],
	"./touch-id.svg": [
		56441,
		[
			3991
		]
	],
	"./tournament-tickets.svg": [
		22941,
		[
			3991
		]
	],
	"./tournaments.svg": [
		91208,
		[
			3991
		]
	],
	"./tribal-white.svg": [
		25324,
		[
			3991
		]
	],
	"./up-for-8.svg": [
		36654,
		[
			3991
		]
	],
	"./upload-documents.svg": [
		69094,
		[
			3991
		]
	],
	"./user-VI.svg": [
		47389,
		[
			3991
		]
	],
	"./user-default-icon.svg": [
		51793,
		[
			3991
		]
	],
	"./user-details.svg": [
		53824,
		[
			3991
		]
	],
	"./user-icon-pre-login-default.svg": [
		15845,
		[
			3991
		]
	],
	"./user.svg": [
		62777,
		[
			3991
		]
	],
	"./vi-cross-sell-casino-mobile.svg": [
		59878,
		[
			3991
		]
	],
	"./vi-cross-sell-poker-mobile.svg": [
		81316,
		[
			3991
		]
	],
	"./vi-logo.svg": [
		98785,
		[
			3991
		]
	],
	"./vip-avatar-gold-VI.svg": [
		33810,
		[
			3991
		]
	],
	"./virtual-sports.svg": [
		82463,
		[
			3991
		]
	],
	"./wallet.svg": [
		5799,
		[
			3991
		]
	],
	"./winloss-history.svg": [
		66492,
		[
			3991
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13254;
module.exports = webpackAsyncContext;